import React from 'react'
import './footer.css'
const Footer = (props) => {
  return (
    <footer style={props.style}>
        <div>
            Created by Team PsyCare
        </div>
        <div>
            <ul>
                <li>&#129409;</li>
                <li>&#129418;</li>
                <li>&#129421;</li>
                <li>&#129429;</li>
                <li>&#129421;</li>
                <li>&#129417;</li>
            </ul>
        

        </div>
    </footer>
  )
}

export default Footer